import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import ScheduleEntity, { ScheduleDay } from "../../entities/ScheduleEntity";
import StablishmentRepository from "../../repositories/StablishmentRepository";

interface _Props {
    stablishmentRepository: StablishmentRepository;
}

@injectable()
export default class GetSchedulesByStablishmentAndDayUseCase {
    private stablishmentRepository: StablishmentRepository;
    
    constructor(props: _Props) {
        this.stablishmentRepository = props.stablishmentRepository;
    }
    
    public call = async (stablishmentId: string, day: Date): Promise<Either<ErrorEntity, ScheduleEntity[]>> => {
        return await this.stablishmentRepository.getSchedulesByStablishmentAndDay(stablishmentId, day);
    }
}

export const GetSchedulesByStablishmentAndDayUseCaseName = "GetSchedulesByStablishmentAndDayUseCase";